import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LikertComponent } from './likert.component';



@NgModule({
  declarations: [
    LikertComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LikertComponent
  ]
})
export class LikertModule { }
